export const basePathRegex = /\/addon-app\/.*?\/(latest|next)\//

export function getBasePathFromUrl(url: string): string {
  const match = basePathRegex.exec(url)
  if (!match) {
    return '/latest/'
  }
  return match[0]
}

export function getCountryFromPath(): string {
  return getLocaleFromPath().split('-')[1]
}

export function getLanguageFromPath(): string {
  return getLocaleFromPath().split('-')[0].toLowerCase()
}

export function getLocaleFromPath(): string {
  const re = /\/(?<channel>latest|next)\/(?<country>[a-z]{2})\/(?<language>[a-z]{2})(?:\/|$)/i
  const match = re.exec(window.location.pathname)

  if (!match?.groups) {
    // biome-ignore lint/suspicious/noConsole: <allow warn>
    console.warn('Locale not found in path, defaulting to en-SE')
    return 'en-SE'
  }

  const country = match.groups.country.toUpperCase()
  const language = match.groups.language.toLowerCase()
  return `${language}-${country}`
}

export function isNAMarket(): boolean {
  return ['CA', 'DO', 'MX', 'PR', 'US'].includes(getCountryFromPath().toUpperCase())
}
